import Client from '../client';
import {flattenObject} from '../helpers';
import {
  GetParcelInventoryItemsRequestBuilder,
  UpdateInventoryItemsRequestBuilder,
  LocateInventoryItemRequestBuilder,
  LocateAllInventoryItemsUnitRequestBuilder,
  RelocateInventoryItemRequestBuilder,
  UpdateInventoryItemsCheckedRequestBuilder,
  UpdateMultiParcelStatusRequestBuilder,
  DeleteInventoryItemFromParcelItemRequestBuilder,
  DeleteByOperatorInventoryItemRequestBuilder,
  UnDeleteInventoryItemRequestBuilder,
} from '../parcels/parcels';
import {
  GetAllInventoryItemsRequestBuilder,
  CreateInventoryItemRequestBuilder,
  GetAllInventoryItems,
  GetInventoryItemsCountRequestBuilder,
} from '../warehouses/warehouses';
import {
  AssignInventoryItemToOrderItemRequestBuilder,
  DeleteInventoryItemFromOrderItemRequestBuilder,
} from '../parcels/parcels';
import {
  LocateInventoryItemUnitForOrderRequestBuilder,
  LocateAllInventoryItemsUnitForOrderRequestBuilder,
} from '../orders/orders';
const token = localStorage.getItem('token') || '';

class InventoryItemRepository {
  assignInventoryItemToOrderItem = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateOrderStatusRequest = new AssignInventoryItemToOrderItemRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return callback;
  };
  deleteInventoryItemFromOrderItem = async (actions: any) => {
    const {id, callback} = actions.payload;
    const makeUpdateOrderStatusRequest = new DeleteInventoryItemFromOrderItemRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return callback;
  };
  deleteInventoryItemFromParcelItem = async (actions: any) => {
    const {id, callback} = actions.payload;
    const makeUpdateOrderStatusRequest = new DeleteInventoryItemFromParcelItemRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateOrderStatusRequest);
    return callback;
  };
  getParcelInventoryItems = async (actions: any) => {
    const {callback, ...actionsPayload} = actions.payload;
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };
  getInventoryItemsWithStatus = async (actions: any) => {
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateMultiInventoryItemsStatus = async (actions: any) => {
    const {body} = actions.payload;
    const makeRequest = new UpdateMultiParcelStatusRequestBuilder()
      .data(body)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateInventoryItems = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new UpdateInventoryItemsRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  updateInventoryItemsChecked = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new UpdateInventoryItemsCheckedRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  locateInventoryItemsUnit = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new LocateInventoryItemRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  locateInventoryItemsUnitForOrder = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new LocateInventoryItemUnitForOrderRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  deleteByOperatorInventoryItems = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new DeleteByOperatorInventoryItemRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  unDeleteInventoryItems = async (actions: any) => {
    const {id, body, callback} = actions.payload;
    const makeUpdateRequest = new UnDeleteInventoryItemRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  locateAllInventoryItemsUnit = async (actions: any) => {
    const {body, callback} = actions.payload;
    const makeUpdateRequest = new LocateAllInventoryItemsUnitRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  locateAllInventoryItemsUnitForOrder = async (actions: any) => {
    const {body, callback} = actions.payload;
    const makeUpdateRequest = new LocateAllInventoryItemsUnitForOrderRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  relocateByaItem = async (actions: any, callback: () => void) => {
    const {payload} = actions;
    const makeRequest = new RelocateInventoryItemRequestBuilder()
      .data(payload)
      .build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return callback;
  };
  getInventoryItems = async (actions: any) => {
    const {callback, ...actionsPayload} = actions.payload;
    const makeRequest = new GetAllInventoryItemsRequestBuilder()
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };
  getAllInventoryItems=async(actions:any)=>{
        const {callback, ...actionsPayload} = actions.payload;
        const makeRequest = new GetAllInventoryItems()
          .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
          .build();

        const client = new Client(token);
        const response = await client.execute(makeRequest);
        return {response, callback};
  }
  getAllInventoryItemsWithSerial = async (actions: any) => {
    const {callback, ...actionsPayload} = actions.payload;
    const makeRequest = new GetAllInventoryItemsRequestBuilder()
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };
  getInventoryItemsWithSerial = async (actions: any, callback: () => void) => {
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response, callback};
  };
  createInventoryItem = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeRequest = new CreateInventoryItemRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback, id};
  };
  getInventoryItemCount = async (actions:any)=>{
    const {...actionsPayload} = actions;
    const makeRequest = new GetInventoryItemsCountRequestBuilder()
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  }
}

export default new InventoryItemRepository();
